import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
    selector: 'app-beroepenpagina',
    templateUrl: './beroepen-pagina-app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BeroepenPaginaAppComponent {
  title = 'beroepenpagina';
}
